export { API_BASE_ROUTE } from "../../../serverConfig"; // TODO: remove and fix import for other files

export const API_REST_METHODS = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATCH",
};

export const API_ERROR_CODES = {
    MODE_CONFLICT: "MODE_CONFLICT",
    RECORD_ALREADY_EXIST: "RECORD_ALREADY_EXIST",
    RULESET_CONFLICT: "RULESET_CONFLICT",
    CONFIG_ERROR: "CONFIG_ERROR",
    UNKNOWN: "UNKNOWN",
};

export const SPACES_TEMPLATE = {
    en: "https://bs360commonstshared.blob.core.windows.net/templates/Vorlage%20Zimmer%20Liste%20Import%20(en).csv",
    de: "https://bs360commonstshared.blob.core.windows.net/templates/Vorlage%20Zimmer%20Liste%20Import.csv",
};

export const DEVICES_TEMPLATE =
    "https://bs360commonstshared.blob.core.windows.net/templates/LoRaWAN%20Device%20Bulk%20Upload%20Template.csv";
